import React, { useEffect, useState } from "react";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';

const styles = {
    spinningIcon: {
        paddingLeft: '2px',
        animation: "spin 2s linear infinite",
        "@keyframes spin": {
            "0%": {
                transform: "rotate(360deg)",
            },
            "100%": {
                transform: "rotate(0deg)",
            },
        },
    },
}

export default function ScorecardTimer() {
    const [startTime, setStartTime] = useState<Date>(new Date());
    const [time, setTime] = useState<string>("");

    useEffect(() => {
        setStartTime(new Date());
        const interval = setInterval(() => getTime(), 1000);
        return () => clearInterval(interval);
    }, []);

    
    const getTime = () => {
        const currentTime = new Date();
        const time = Date.parse(currentTime.toString()) - Date.parse(startTime.toString());
        let timerString = "";

        let hours = (Math.floor((time / (1000 * 60 * 60)) % 24));
        let minutes = (Math.floor((time / 1000 / 60) % 60));
        let seconds = (Math.floor((time / 1000) % 60));
        if (hours < 10) {
            timerString += ("0" + hours)
        }
        else {
            timerString += hours;
        }
        if (minutes < 10) {
            timerString += (":0" + minutes);
        }
        else {
            timerString += (":" + minutes);
        }
        if (seconds < 10) {
            timerString += (":0" + seconds);
        }
        else {
            timerString += (":" + seconds);
        }
        setTime(timerString)
    };
    return (
        <>
            {"Scorecard " + time}
            < HourglassBottomIcon sx={styles.spinningIcon} />
        </>
    )
}